import type { IconProps } from '@openeducation/oe-rn-shared-types';
import React from 'react';
import { useTheme } from 'react-native-paper';
import Svg, { Path } from 'react-native-svg';

export const CheckIcon = ({ fill, width = 25 }: IconProps) => {
  const { colors } = useTheme();

  return (
    <Svg width={width} height="19" viewBox="0 0 25 19" fill="none">
      <Path
        d="M8.85059 18.125C9.31934 18.5938 10.1162 18.5938 10.585 18.125L24.3662 4.34375C24.835 3.875 24.835 3.07812 24.3662 2.60938L22.6787 0.921875C22.21 0.453125 21.46 0.453125 20.9912 0.921875L9.74121 12.1719L4.44434 6.92188C3.97559 6.45312 3.22559 6.45312 2.75684 6.92188L1.06934 8.60938C0.600586 9.07812 0.600586 9.875 1.06934 10.3438L8.85059 18.125Z"
        fill={fill || colors.background}
      />
    </Svg>
  );
};
